export enum PsoUserOptionsEnum {
    None,
    Resident,
    Worker,
    Family
}